export default __webpack_public_path__ + "static/media/logo-black-text.ad6ddc315d2806ad019892ac18c6c86a.svg";